import { extractBasedOnSymbology } from "@coworker/apprestructured/src/scan-and-search/helpers/extractBasedOnSymbologyUtils";
import { useBarcodeReader } from "@coworker/apprestructured/src/scan-and-search/hooks/useBarcodeReader";
import { ScanResultType } from "@coworker/apprestructured/src/scan-and-search/types/ScanResultType";
import { SymbologyType } from "@coworker/apprestructured/src/scan-and-search/types/SymbologyType";

export const Scanner = ({
  handleScannedArticle,
}: {
  handleScannedArticle: (articleId?: string) => void;
}) => {
  useBarcodeReader((data, type) => {
    const scanResult: ScanResultType = {
      scannedBarcode: data,
      symbologyFormat: type as SymbologyType,
    };

    const articleInformation = extractBasedOnSymbology(
      scanResult.symbologyFormat,
      scanResult.scannedBarcode
    );

    handleScannedArticle(articleInformation.articleNumber);
  });

  return null;
};
